<template>
  <div>
    <div class="ori-detail-header" :style="{backgroundImage:`url(${backgroundImage})`}">
      <div class="ori-hd-pic">
        <img :src="header.picPath" alt />
      </div>
      <div class="ori-hd-name">
        <p>{{header.title}}</p>
        <p>
          <span>今天</span>
          <span>{{header.now.slice(0,10)}}</span>
          <span>{{header.dayOfWeek}}</span>
          <span>天气：{{weather}}</span>
        </p>
      </div>
      <div class="ori-hd-handle">
        <p @click="cooperationDir=!cooperationDir">我的协作</p>
        <p @click="signDir=!signDir"><img src="../../../../../html/pages/originality/visaFlowIndex/images/sign.png" alt=""> 签到详情</p>
      </div>
    </div>
    <div class="crumbs-box">
      <router-link tag="a" class="c-crumbs" :to="{name:'default'}">首页</router-link>
      <span class="c-sep">&gt;</span>
      <span>匠心记</span>
      <span class="c-sep">&gt;</span>
      <span class="c-current">{{header.title}}</span>
    </div>
    <!-- 我的协作mask -->
    <div class="shadow-fixed show" v-if="cooperationDir">
      <div class="mask"></div>
      <div class="pop-box">
        <div class="pop-small-close" @click="cooperationDir=!cooperationDir"></div>
        <div class="pop-entrance">
          <div @click="gotoVisaflow">
            <img src="../../../../../html/pages/originality/originality/images/visa.png" alt />
            <p>指令单流程</p>
          </div>
          <div @click="gotoLogistics">
            <img src="../../../../../html/pages/originality/originality/images/Logistics.png" alt />
            <p>协作流</p>
          </div>
          <div>
            <img src="../../../../../html/pages/originality/originality/images/process.png" alt />
            <p>工序交接流</p>
          </div>
        </div>
      </div>
    </div>
    <d-qiandao v-if="signDir" @close="signDir=!signDir"></d-qiandao>
  </div>
</template>

<script>
import "../../../../../html/components/detailHeader/detailHeader.scss"
import '../../../../../html/components/crumbs/crumbs.scss';
import '../../../../../html/pages/originality/originality/originality.scss';
import "../../../../../html/components/popCommon/popCommon.scss";

import dQiandao from '../../detail/components/d-qiandao';

import { getJxjDetail, getWeather } from '../../../../../api/index.js';

export default {
  name: 'detailHeader',
  components: {
    dQiandao,
  },
  data() {
    return {
      cooperationDir: false,
      signDir: false,
      header: { now: '', picPath: '' },
      weather: '',
      backgroundImage: '',
      sunnyImage: './gif/sunny.gif',
      hotImage: './gif/hot.gif',
      rainImage: './gif/rain.gif',
      snowImage: './gif/snow.gif',
      cloudyImage: './gif/cloudy.gif',
      fogImage: './gif/fog.gif',
    };
  },
  methods: {
    gotoVisaflow() {
      this.cooperationDir = false;
      this.$router.push(`/originality/visaflowIndex/${this.$route.params.id}/1`)
    },
    gotoLogistics() {
      this.cooperationDir = false;
      this.$router.push(`/originality/logisticsIndex/${this.$route.params.id}/1/1`)
    },
    async getHeader() {
      let res = await getJxjDetail({
        id: this.$route.params.id
      });
      if (res.Type == 'Success') {
        this.header = res.Data;
      }
    },
    async getWeather() {
      let res = await getWeather({
        city: '苏州'
      });
      if (res.Type == 'Success') {
        this.weather = res.Data;
        switch (this.weather) {
          case "晴":
            this.backgroundImage = this.sunnyImage;
            break;
          case "高温":
            this.backgroundImage = this.hotImage;
            break;
          case "雨":
            this.backgroundImage = this.rainImage;
            break;
          case "雪":
            this.backgroundImage = this.snowImage;
            break;
          case "雾":
            this.backgroundImage = this.fogImage;
            break;
          case "阴":
            this.backgroundImage = this.cloudyImage;
            break;
        }
      }
    },
  },
  created() {
    this.getWeather();
    this.getHeader();
  },
  watch: {
    $route(to, from) {
      this.getWeather();
      this.getHeader();
    }
  },
};
</script>

<style>
</style>
